(function () {
  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return document.querySelectorAll(sel); }

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Mobile nav drawer ─────────────────────────── */
    var btn = qs('[data-bff-menu-toggle]');
    var nav = qs('[data-bff-mobile-nav]');
    var backdrop = qs('[data-bff-mobile-nav-backdrop]');

    function setMobileNav(open) {
      if (!btn || !nav) return;
      nav.hidden = !open;
      if (backdrop) backdrop.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('bff-mobile-nav-open', open);
    }

    if (btn && nav) {
      btn.addEventListener('click', function () {
        setMobileNav(nav.hidden);
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () { setMobileNav(false); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMobileNav(false);
    });

    qsa('[data-bff-mobile-accordion]').forEach(function (accBtn) {
      accBtn.addEventListener('click', function () {
        var panel = accBtn.parentElement && accBtn.parentElement.querySelector('.bff-mobile-nav__submenu');
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        accBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ── Desktop dropdown toggles (all [data-bff-dropdown]) ── */
    function closeAllDropdowns(except) {
      qsa('[data-bff-dropdown]').forEach(function (b) {
        if (b === except) return;
        var panel = b.parentElement && b.parentElement.querySelector('.bff-nav-dropdown__panel');
        if (panel) {
          panel.hidden = true;
          b.setAttribute('aria-expanded', 'false');
        }
      });
    }

    qsa('[data-bff-dropdown]').forEach(function (ddBtn) {
      var ddPanel = ddBtn.parentElement && ddBtn.parentElement.querySelector('.bff-nav-dropdown__panel');
      if (!ddPanel) return;

      ddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !ddPanel.hidden;
        closeAllDropdowns(ddBtn);
        ddPanel.hidden = open;
        ddBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    document.addEventListener('click', function (e) {
      qsa('[data-bff-dropdown]').forEach(function (ddBtn) {
        var ddPanel = ddBtn.parentElement && ddBtn.parentElement.querySelector('.bff-nav-dropdown__panel');
        if (!ddPanel) return;
        var wrapper = ddBtn.closest('.bff-category-nav__dropdown, .bff-category-nav__more');
        if (!wrapper || !wrapper.contains(e.target)) {
          ddPanel.hidden = true;
          ddBtn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* ── Collection facet panel ────────────────────── */
    var facetPanel = qs('[data-bff-facets-panel]');
    function syncFacetPanel() {
      if (!facetPanel) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        facetPanel.hidden = false;
      }
    }
    syncFacetPanel();
    window.addEventListener('resize', syncFacetPanel);

  });
})();
